var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisputeRelatedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1582 1.02344V6.35677C13.1582 6.71039 13.2987 7.04953 13.5487 7.29958C13.7988 7.54963 14.1379 7.6901 14.4915 7.6901H19.8249",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 25.0234H3.83268C3.12544 25.0234 2.44716 24.7425 1.94706 24.2424C1.44697 23.7423 1.16602 23.064 1.16602 22.3568V3.6901C1.16602 2.98286 1.44697 2.30458 1.94706 1.80449C2.44716 1.30439 3.12544 1.02344 3.83268 1.02344H13.166L19.8327 7.6901V22.3568C19.8327 23.064 19.5517 23.7423 19.0516 24.2424C18.5515 24.7425 17.8733 25.0234 17.166 25.0234Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13444_45938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.166 9.02344C7.12591 9.02344 4.66602 11.4835 4.66602 14.5234C4.66602 17.5635 7.12613 20.0234 10.166 20.0234C13.2061 20.0234 15.666 17.5633 15.666 14.5234C15.666 11.4833 13.2059 9.02344 10.166 9.02344ZM10.166 19.1641C7.60093 19.1641 5.52539 17.0883 5.52539 14.5234C5.52539 11.9584 7.6011 9.88281 10.166 9.88281C12.7311 9.88281 14.8066 11.9585 14.8066 14.5234C14.8066 17.0885 12.7309 19.1641 10.166 19.1641Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.166 11.791C9.9287 11.791 9.73633 11.9834 9.73633 12.2207V14.9877C9.73633 15.2251 9.9287 15.4174 10.166 15.4174C10.4033 15.4174 10.5957 15.2251 10.5957 14.9877V12.2207C10.5957 11.9834 10.4033 11.791 10.166 11.791Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.166 17.1055C10.4864 17.1055 10.7461 16.8458 10.7461 16.5254C10.7461 16.205 10.4864 15.9453 10.166 15.9453C9.84565 15.9453 9.58594 16.205 9.58594 16.5254C9.58594 16.8458 9.84565 17.1055 10.166 17.1055Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13444_45938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(4.66602 9.02344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeRelatedIcon);
export default __webpack_public_path__ + "static/media/DisputeRelatedIcon.a15b60344196348853a8f8fe252c05c7.svg";
export { ForwardRef as ReactComponent };